import React from 'react'
import PropTypes from 'prop-types'

import { useTransitionService } from '@/services/TransitionService'
import { ResizeService } from '@/services/ResizeService'
import { Metadata } from '@/components/Metadata'
import { PageTransition } from '@/components/PageTransition'
import { Header } from '@/components/Header'
import { Footer } from '@/components/Footer'
import { Menu } from '@/components/Menu'
import { WelcomeOverlay } from '@/components/WelcomeOverlay'

import '@/styles/main.scss'
import * as styles from './Layout.styles.scss'

const Layout = ({ site, page, children }) => {
  useTransitionService()

  return (
    <div>
      <Metadata
        title={page.title}
        defaultTitle={
          site.metadata.subtitle
            ? `${site.metadata.title}: ${site.metadata.subtitle}`
            : site.metadata.title
        }
        titleTemplate={`%s — ${site.metadata.title}`}
        favicon={site.favicon}
        description={site.metadata.description}
        image={page.image || site.metadata.image}
        siteUrl={site.metadata.siteUrl}
        path={page.path}
      />
      <ResizeService>
        <div className={styles.Layout}>
          <Menu {...site.menu} />
          <Header {...site.header} />
          <WelcomeOverlay {...site.acknowledgement} />
          <main className={styles.main}>{children}</main>
          <Footer {...site.footer} />
          <PageTransition />
        </div>
      </ResizeService>
    </div>
  )
}

Layout.defaultProps = {
  site: {},
  page: {},
}

Layout.propTypes = {
  site: PropTypes.object,
  page: PropTypes.object,
  children: PropTypes.node.isRequired,
}

export default Layout
